import React, { useState, useEffect } from 'react';
import { withFormik } from 'formik';
import Service from '../../../../../apiService';
import View from './View';
import useDataFetching from '../../../../hooks/useDataFetching';
import apiService from '../../../../../apiService';
import Alert from 'view/component/Alert';

const FormPenilaianHotel = ({ data, values, setFieldValue, handleSubmit }) => {
  const [score, setScore] = useState('');
  const [examinerName, setExaminerName] = useState('');
  const { error, loading, results } = useDataFetching({
    url: '/hotel/question/read',
    method: 'get',
  });

  const { results: penilaianResult } = useDataFetching({
    url: `/hotel/answer/count/${data.hotel_health_check.id}`,
    method: 'get',
  });

  const handleInputChange = (e) => {
    setFieldValue('examinerName', e.target.value);
  };

  const row = rowMapper(results.data || []);

  const handleChange = (e, id, value) => {
    if (e.target.checked) {
      setScore((state) => ({
        ...state,
        [id]: state[id]
          ? parseInt(state[id]) + parseInt(e.target.value)
          : e.target.value,
      }));
      setFieldValue(value, {
        question_id: value,
      });
    } else {
      setScore((state) => ({
        ...state,
        [id]: parseInt(state[id]) - parseInt(e.target.value),
      }));
      setFieldValue(value, '');
    }
  };

  return (
    <View
      row={row}
      data={data}
      score={score}
      values={values}
      penilaianResult={penilaianResult}
      examinerName={examinerName}
      setExaminerName={setExaminerName}
      handleInputChange={handleInputChange}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      setFieldValue={setFieldValue}
    />
  );
};
export default withFormik({
  mapPropsToValues: (props) => ({}),
  handleSubmit: async (values, { props }) => {
    const post = Object.entries(values)
      .filter(([key, value]) => key !== 'examinerName' && value)
      .map(([key, value]) => value);
    const result = await apiService.post('hotel/answer/create', {
      examiner: values.examinerName,
      hotel_health_check_id: props.data.hotel_health_check.id,
      data: post,
    });
    if (result.code === 200) Alert('success', 'Penilaian Berhasil');
  },
})(FormPenilaianHotel);

//helper

const rowMapper = (questions) => {
  const row = [];
  questions.forEach((question) => {
    row.push([question.question]);
    question.ref_child.forEach((child) =>
      row.push([
        child.question,
        child.ref_sub_child.map((subChild) => ({
          label: `${subChild.question} (nilai : ${subChild.value})`,
          value: subChild.value,
          id: subChild.id,
        })),
        child.ref_sub_child[0].weight,
      ])
    );
  });

  return row;
};
